import React, { Component } from 'react'
import { FaWpforms, FaSave, FaFolder } from 'react-icons/fa'
import { v4 as uuidv4 } from 'uuid'

import { ModalOne } from '../../../../lib/modal'
import { InputOne } from '../../../../lib/input'
import { SelectOne } from '../../../../lib/select'
import { GridBlock } from '../../../../lib/grid'
import { FormLayout } from '../../../Layouts'
import { getTranslatation } from '../../../../../locales/translate'

import { getReduceState } from '../../../../../components/funcs/BASES/getStateOfRed'

export default class AddModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      hareketler_hareketler_id: '',
      egzSet: '',
      tekrar: '',
      uuid: ''
    }
  }

  submit = () => {
    this.setState(
      {
        uuid: uuidv4()
      },
      () => {
        this.props.fakeThis.setState(
          {
            datas: [...this.props.fakeState.datas, this.state],
            modalIsOpen: false
          },
          () => {
            this.setState({
              hareketler_hareketler_id: '',
              egzSet: '',
              tekrar: '',
              uuid: ''
            })
          }
        )
      }
    )
  }

  setVal = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render () {
    const AlldetailsReducers = getReduceState('AlldetailsReducers')
    return (
      <ModalOne
        open={this.props.open}
        bgDropColor={'rgba(128, 2, 255, 0.2)'}
        fullScreen={true}
      >
        <FormLayout
          naviIcon={<FaWpforms size={30} color={'white'} />}
          recordIcon={<FaSave size={30} color={'white'} />}
          recordAction={this.submit}
          // filesIcon={<FaFolder size={30} color={'white'} />}
          activeBack={() => {
            this.props.fakeThis.setState({ modalIsOpen: false })
          }}
          loading={false}
        >
          <GridBlock
            title={getTranslatation('egzersizehareketbağlayın', 'EXERCISE')}
            container={true}
            xs={12}
            sm={12}
            lg={12}
          >
            <InputOne
              type={'number'}
              color={'success'}
              variant='filled'
              margin='none'
              required
              fullWidth
              xs={12}
              sm={12}
              lg={4}
              id='egzSet'
              label={getTranslatation('egzSet', 'EXERCISE')}
              name='egzSet'
              value={this.state.egzSet}
              onChange={this.setVal}
              // error={this.state.mailOrPhone_ERROR.length > 0}
              helperText={getTranslatation('egzSetHelper', 'EXERCISE')}
            />

            <InputOne
              type={'number'}
              color={'success'}
              variant='filled'
              margin='none'
              required
              fullWidth
              xs={12}
              sm={12}
              lg={4}
              id='tekrar'
              label={getTranslatation('tekrar', 'EXERCISE')}
              name='tekrar'
              value={this.state.tekrar}
              onChange={this.setVal}
              // error={this.state.mailOrPhone_ERROR.length > 0}
              helperText={getTranslatation('tekrarHelper', 'EXERCISE')}
            />

            <SelectOne
              placeholder={getTranslatation('hareketler', 'EXERCISE')}
              label={getTranslatation('hareketler', 'EXERCISE')}
              helperText={getTranslatation('hareketlerHelper', 'EXERCISE')}
              xs={12}
              sm={12}
              lg={4}
              value={this.state.hareketler_hareketler_id}
              onChange={this.setVal}
              name='hareketler_hareketler_id'
              id='hareketler_hareketler_id'
              options={AlldetailsReducers?.AllDetails?.Hareketler}
            />
          </GridBlock>
        </FormLayout>
      </ModalOne>
    )
  }
}
